<template>
    <el-drawer
        title="周边结款信息"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <ReceiptInfo v-if="drawerShow" ref="receiptInfo" :id="data.applyUserId" :showHistoryAudiList="false"></ReceiptInfo>
            <div v-if="data2" class="group MT20">
                <div class="page-group-title"><span>结款身份</span></div>
                <table class="info-table MT20" style="width:100%">
                    <tr>
                        <th>结款方身份</th>
                        <td>{{ $userType.get(data2.applyUserType) }}</td>
                    </tr>
                    <tr>
                        <th>结款方ID</th>
                        <td>{{ data2.applyUserId }}</td>
                    </tr>
                    <tr>
                        <th>结款方名称</th>
                        <td>{{ data2.applyUserName }}</td>
                    </tr>
                </table>
            </div>
            <div v-if="data2" class="group MT20">
                <div class="page-group-title"><span>结款金额</span></div>
                <table class="info-table MT20" width="100%">
                    <tr>
                        <th>销售截止时间</th>
                        <td>{{data2.applyEndTime}}</td>
                        <th>结算单状态</th>
                        <td>
                            <span v-if="data.status == 1" class="color-danger">待结款</span>
                            <span v-else-if="data.status == 2">已结款</span>
                            <span v-else class="color-info">已拒绝</span>
                        </td>
                    </tr>
                    <tr>
                        <th>销售商品数</th>
                        <td>{{data2.saleNum}}</td>
                        <th>销售金额<span class="color-info font10">(由收入扣除未结算且待退款和已退款的金额而来)</span></th>
                        <td class="color-danger">{{data2.saleAmountFormat}}</td>
                    </tr>
                    <tr>
                        <th>商家承担优惠</th>
                        <td>{{data2.busDiscountFormat}}</td>
                        <th>服务费用</th>
                        <td colspan="3">{{data2.serviceFeeAmountFormat}}</td>
                    </tr>
                    <tr>
                        <th>已结算商品退款数</th>
                        <td>{{ data2.refundNum || 0}}</td>
                        <th>已结算商品退款金额<span class="color-info font10">(将返回之前结算时扣除的服务费)</span></th>
                        <td class="color-danger">{{data2.refundAmountStr || 0}} - {{data2.refundAmountServiceStr || 0}} = {{ data2.refundAmountFinalStr || 0}}</td>
                    </tr>
                    <tr>
                        <th>预计结款</th>
                        <td colspan="3" class="color-danger">
                            {{ data2.saleAmountFormat }} - {{ data2.busDiscountFormat }} - {{ data2.serviceFeeAmountFormat }} - {{ data2.refundAmountFinalStr || 0}} =
                            {{ data2.proposeAmountFormat }}
                            <p class="color-info">销售金额 - 商家承担优惠 - 服务费用 - 已结算商品退款金额<span class="font10">(将返回之前结算时扣除的服务费)</span></p>
                        </td>
                    </tr>
                </table>
            </div>
            
            <div v-if="data" class="group MT20">
                <div class="page-group-title"><span>结款信息</span></div>
                <SettlementEdit v-if="drawerShow" ref="settlementEdit" :id="id" :btnLoading.sync="btnLoading"></SettlementEdit>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="onSubmit()" :loading="btnLoading">确 定</el-button>
        </div>
    </el-drawer>
</template>
<script>
import SettlementEdit from '../../components/settlementEdit';
import ReceiptInfo from '../../components/receiptInfo';
export default {
    components:{ReceiptInfo,SettlementEdit},
    data(){
        return{
            drawerShow: false,
            btnLoading:false,
            id:'',
            data:null,
            data2: null,
            dataLoading2:false,
        }
    },
    methods:{
        close(){
            // if(this.$refs.formData) this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(data){
            this.id = data.id || '';
            this.data = data;
            this.btnLoading = false;
            this.getData2();
            this.drawerShow = true;
        },
        //获取销售信息统计
        getData2(){
            this.dataLoading2 = true;
            this.$request({
                url: '/goodsReceivablesAudit/audi/sale/statistic',
                params: {
                    id: this.id,
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data2 = result;
                    } else {
                        this.$message.error(msg || "获取销售信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取销售信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading2 = false;
                });
        },
        onSubmit(){
            this.$refs.settlementEdit.onSubmit(() => {
                this.close();
                this.$emit('onUpdate');
            })
        }
    }
}
</script>
<style lang="scss" scoped>

.font10{
	font-size: 10px;
}
</style>